/**
 * Returns 'yyyy-MM-dd' of string, removing timezone if it exists
 * @param {string} date
 */
const formatDateStringNoTimezone = (date) => {
    return date === null || date === void 0 ? void 0 : date.substring(0, 10);
};
export default formatDateStringNoTimezone;
